import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
  },

  mutations: {
  },

  actions: {
    searchDuplicateMovements: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/duplicateMovementsAnalysis/list/duplicated', filter).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    searchAnnulledMovements: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/duplicateMovementsAnalysis/list/annulled', filter).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    annulledMovements: ({ commit }, movements) => {
      return new Promise((resolve, reject) => {
        axios.post('/duplicateMovementsAnalysis/update/annulled', movements).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },

  getters: {
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/duplicateMovementsAnalysis.js